import React, { useMemo, useReducer } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { useTranslate } from 'core/translate';
import NotificationsContext from './NotificationsContext';
import {
  SHOW_MESSAGE,
  DISMISS_MESSAGE,
  reducer,
  createDefault,
} from './notifications';

export function onOpenDisclosure(event, show, incentiveDisclaimers) {
  event.preventDefault();
  show(incentiveDisclaimers, event);
}

const showMessage = (message, event, messageIcon, useModal = false) => {
  if (event && event.persist) {
    event.persist();
  }
  return {
    type: SHOW_MESSAGE,
    payload: { message, event, messageIcon, useModal },
  };
};

const NotificationsProvider = (props) => {
  const {
    disabled,
    children,
    simpleDisclaimer,
    incentivesDisclaimer,
    disclosures,
  } = props;
  const translate = useTranslate();
  const [state, dispatch] = useReducer(reducer, createDefault());
  const { target, message, visible, messageIcon, useModal } = state;

  function getNamedMessage(name) {
    switch (name) {
      case 'msrp-simple':
        return simpleDisclaimer;
      case 'accessories':
        return translate('accessories.price.disclaimer');
      case 'msrp':
        return incentivesDisclaimer;
      case 'ev':
        return translate('component.pricing.ev.disclaimer');
      case 'employee-net-price':
        return translate('byo.disclaimer.employee.net.price');
      case 'total-employee-price':
        return translate('byo.disclaimer.total.employee.price');
      case 'total-price':
        return translate('byo.disclaimer.total.price');
      default:
        return '';
    }
  }

  const context = useMemo(() => {
    return {
      show(text, event, messageIcon, useModal) {
        dispatch(showMessage(text, event, messageIcon, useModal));
      },
      showNamed(name, event, useModal) {
        const message = getNamedMessage(name);
        dispatch(showMessage(message, event, null, useModal));
      },
      showById(id, event) {
        const message = _.get(disclosures, id);
        dispatch(showMessage(message, event));
      },
      dismiss() {
        dispatch({ type: DISMISS_MESSAGE });
      },
      disabled,
      target,
      message,
      messageIcon,
      visible,
      disclosures,
      useModal,
    };
  }, [
    disabled,
    target,
    message,
    messageIcon,
    visible,
    simpleDisclaimer,
    incentivesDisclaimer,
    disclosures,
    useModal,
  ]);

  return (
    <NotificationsContext.Provider value={context}>
      {children}
    </NotificationsContext.Provider>
  );
};

const mapStateToProps = (state) => {
  const simpleDisclaimer = _.get(state, 'disclaimers.simple');
  const incentivesDisclaimer = _.get(state, 'incentives.disclaimer');
  const disclosures = _.get(state, 'disclosures');
  return {
    simpleDisclaimer,
    incentivesDisclaimer,
    disclosures,
  };
};

export default connect(mapStateToProps)(NotificationsProvider);
